import React, { useState } from 'react';


export const Candidat = () => {



    return(
      <>
      <div style={{ backgroundColor: '#CBD0D8'}}>
       <h1 className="glowing-text" style={{ 
        fontWeight: 'bold', 
        textAlign: 'center', 
        background: 'linear-gradient(to right, blue, red)', 
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontSize: '36px' 
      }}>
        BIENVENUE SUR L'Application d'entrainnement <br/>aux pre-inscription en ligne du test de <br/>langue cas de l'IFC de Douala-yaounde
      </h1>
      <section class="section normalhead" >
     <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 text-center">
          
           <h1>La réussite de votre procédure nous préoccupe...</h1>
          </div>
         
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '60px 0' }}>
        <a className="btn" href="/faq/">   <button className="glowing-button" >
                  Commencer la simulation
                </button></a>
                </div> 
      </div>
      
    </section>
   
    </div>
    
    <footer className="footer secondary-footer"  style={{ backgroundColor: '#928490 ' }}>
  <div className="container">
    <div className="row">
      <div className="col-md-12 col-sm-12 col-xs-12" style={{ textAlign: "center" }}>
        <p>2024 &copy;Objectif Canada</p>
      </div>
    </div>
  </div>
 
</footer>
       </> 
    )
    }